import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { jobCategories, workTypes, englishLevels, tagNames } from '../../constants/jobFilterValues';
import PrettyTagSelector from '../common/PrettyTagSelector';
import Selector from '../common/Selector';

const useStyles = makeStyles((theme) => ({
    filterContainer: {
        padding: theme.spacing(3),
        backgroundColor: '#ebf7fe',
        '& h4': {
            marginBottom: theme.spacing(2)
        },
    },
    flexContainer: {
        display: 'flex',
        gap: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        },
    },
    section: {
        marginTop: theme.spacing(2)
    },
    button: {
        padding: '8px 24px',
        fontSize: '1.6rem',
        backgroundColor: theme.palette.success.main,
        color: theme.palette.common.white,
        margin: '0 auto',
        '&:hover': {
            backgroundColor: theme.palette.success.dark
        }
    },
    buttonContainer: {
        padding: '3rem 0',
        textAlign: 'center'
    }
}));

function JobFilter(props) {
    const classes = useStyles();
    const initialFilter = useSelector(state => state.job.searchFilter);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        setFilter(initialFilter);
    }, [initialFilter]);

    const handleFilterChange = (name, data) => {
        let newFilter = { ...filter };
        if (data) {
            newFilter[name] = data;
        } else {
            newFilter[name] = undefined;
        }
        setFilter(newFilter);
    };

    const onSaveFilter = () => {
        props.onSaveFilter(filter);
    };

    let selectedTags = filter.tags ? filter.tags : [];
    let selectedCategories = filter.jobCategory ? filter.jobCategory : [];

    return (
        <Box className={`${classes.filterContainer} jobFilter`}>
            <Typography variant="h4" component="h4">
                職種
            </Typography>
            <Box>
                <PrettyTagSelector
                    dataList={jobCategories}
                    onChange={(data) => handleFilterChange('jobCategory', data)}
                    values={selectedCategories}
                />
            </Box>
            <Box className={classes.flexContainer}>
                <Box className={classes.section}>
                    <Typography variant="h4" component="h4">
                        雇用形態
                    </Typography>
                    <Selector
                        dataList={workTypes}
                        onChange={e => handleFilterChange(e.target.name, e.target.value)}
                        name="workType"
                        value={filter.workType}
                        emptyString='全て'
                    />
                </Box>
                <Box className={classes.section}>
                    <Typography variant="h4" component="h4">
                        必要英語力
                    </Typography>
                    <Selector
                        dataList={englishLevels}
                        onChange={e => handleFilterChange(e.target.name, e.target.value)}
                        name="englishLevel"
                        value={filter.englishLevel}
                        emptyString='全て'
                    />
                </Box>
            </Box>

            <Box className={classes.section}>
                <Typography variant="h4" component="h4">
                    タグ
                </Typography>
                <PrettyTagSelector
                    dataList={tagNames}
                    onChange={(data) => handleFilterChange('tags', data)}
                    values={selectedTags}
                />
            </Box>
            <Box className={classes.buttonContainer}>
                <Button
                    onClick={onSaveFilter}
                    variant="contained"
                    size="large"
                    className={classes.button}
                >
                    フィルターを適用する
                </Button>
            </Box>
        </Box>
    );
}

JobFilter.propTypes = {
    onSaveFilter: PropTypes.func
};

export default JobFilter;